import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Mail, ArrowLeft } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const NAVY = '#0A1F44';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setSent(true); // never reveal whether the email exists
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: '#F5F1E8' }}>
      <div className="w-full max-w-md bg-white rounded-3xl p-8 shadow-xl" data-testid="forgot-password-page">
        <Link to="/auth" className="inline-flex items-center gap-2 text-sm mb-6" style={{ color: '#4a5568' }}>
          <ArrowLeft className="w-4 h-4" /> Back to sign in
        </Link>
        <h1 className="text-2xl font-bold mb-2" style={{ color: NAVY, fontFamily: 'Outfit, sans-serif' }}>Reset your password</h1>
        {sent ? (
          <p className="text-sm leading-relaxed" style={{ color: '#4a5568' }} data-testid="forgot-sent">
            If an account exists for that email, we have sent a reset link. Please check your inbox (and spam folder). The link expires in 1 hour.
          </p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm" style={{ color: '#4a5568' }}>Enter your email and we will send you a link to reset your password.</p>
            <div className="relative">
              <Mail className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2" style={{ color: '#94a3b8' }} />
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com"
                data-testid="forgot-email-input"
                className="w-full pl-9 pr-3 py-3 rounded-xl border outline-none" style={{ borderColor: '#e2e8f0', color: NAVY }} />
            </div>
            <button type="submit" disabled={loading} data-testid="forgot-submit"
              className="w-full py-3 rounded-full font-bold text-white disabled:opacity-60" style={{ background: NAVY }}>
              {loading ? 'Sending…' : 'Send reset link'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
